// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f05af96dd655636b0d00239c7ee8b1da64915b37.chunk.js";
};